<template>

    <div class="page">
        <SidebarBody/>
        <WalletBody/>
    </div>
    
  </template>
  
  <script>
  import { defineComponent } from "vue";
  import SidebarBody from "@/components/dashboard/SidebarBody.vue";
  import WalletBody from "@/components/dashboard/WalletBody.vue";
  
  export default defineComponent({
    name: "WalletView",
    components: {
      SidebarBody,
      WalletBody
    },
  });
  </script>
  